var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-div col"},[_c('dv-scroll-board',{attrs:{"config":{..._vm.config,data: _vm.data}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }